import { render } from "./FaultyProductItem.vue?vue&type=template&id=1246f194&ts=true"
import script from "./FaultyProductItem.vue?vue&type=script&lang=ts"
export * from "./FaultyProductItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__